import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Tab, Card, Spinner, Modal, Button } from "react-bootstrap";
import Block from "../../components/Block/Block";
import { connect } from "react-redux";
import { Icon, MediaGroup, MediaText, Media, Image } from "../../components";
import { toInitials } from "../../utilities";
import { getStopApi, updateStopApi } from "../../services/TransportService";
import { format } from "date-fns";
import DataTable from "react-data-table-component";
import Addstopmodal from "./Addstopmodal";
import IconButton from "@mui/material/IconButton";
import { IoCloseOutline } from "react-icons/io5";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Stopmap from "./Stopmap";
import { toast } from "react-toastify";
import StopActivePass from "./StopActivePass";
function StopDetailsPage({ userRole }) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addFormFields, setAddFormFields] = useState({
    name: "",
    longitude: "",
    latitude: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [isAddSubmiting, setIsAddSubmiting] = useState(false);
  const [mapOpen, setMapopen] = useState(false);
  const handleopen = () => {
    setMapopen(true);
  };
  const handleclose = () => {
    setMapopen(false);
  };
  const navigate = useNavigate();

  const fetchStop = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getStopApi(id);
      setData(response?.data);
    } catch (err) {
      setError(err.message || "An error occurred while fetching data data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchStop();
  }, [id]);

  // const handleToggleModal = () => {
  //   if (modalVisible) {
  //     setAddFormFields({
  //       name: "",
  //       longitude: "",
  //       latitude: "",
  //     });
  //   } else {
  //     setAddFormFields({
  //       name: data?.stop?.name || "",
  //       longitude: data?.stop?.longitude || "",
  //       latitude: data?.stop?.latitude || "",
  //     });
  //   }
  //   setModalVisible((prev) => !prev);
  // };

  const handlesubmit = (data) => {
    setIsAddSubmiting(true);
    updateStopApi(id, data)
      .then((resp) => {
        setData((prev) => ({ ...prev, bus: resp.data }));
        setModalVisible(false);
        toast.success("Update successfully");
        fetchStop();
      })
      .catch((error) => {
        console.error(error?.response?.data?.message);
      })
      .finally(() => {
        setIsAddSubmiting(false);
      });
  };

  const columns = [
    {
      name: "Employee",
      selector: (row) => (
        <MediaGroup>
          <Media size="md" shape="circle" variant="dark-soft">
            {row?.employee?.profile_photo ? (
              <Image
                src={`${process.env.REACT_APP_BASE_URL}${row?.employee?.profile_photo}`}
                staticImage
                alt="user"
              />
            ) : (
              <span className="fw-medium">
                {toInitials(row?.employee.name)}
              </span>
            )}
          </Media>

          <MediaText>
            <Link
              to={`/employee/${row?.employee.id}`}
              className="title text-uppercase text-primary"
            >
              <strong>{row?.employee.name}</strong>{" "}
            </Link>
            <Link to={`/employee/${row?.employee.id}`}>
              <span className="small text">{row?.employee.email}</span>
            </Link>
          </MediaText>
        </MediaGroup>
      ),
      wrap: true,
      grow: 2,
    },
    {
      name: "Route No.",
      selector: (row) => row.route?.route_number || "-",
    },
    {
      name: "Bus",
      selector: (row) => row.bus?.number_plate,
      grow: 2,
      wrap: true,
    },
    {
      name: "Validity",
      selector: (row) =>
        `${format(new Date(row.start_date), "d MMMM yyyy")}  To ${format(
          new Date(row.end_date),
          "d MMMM yyyy"
        )}`,
      wrap: true,
      sortable: false,
    },
    {
      name: "Inbound Time",
      selector: (row) => {
        const start = new Date(`1970-01-01T${row.departure_time}`);
        return `${format(start, "h.mm a")}`;
      },
    },
  ];

  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <div>
      {/* <Tab.Container defaultActiveKey="tabOne">
        <Block className="mt-2">
          <Tab.Content>
            <Tab.Pane eventKey="tabOne">
              <Card className="card-gutter-md">
                <div className="card-row card-row-lg col-sep col-sep-lg">
                  <div className="card-aside">
                    <Card.Body>
                      <div className="bio">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm btn-circle"
                              onClick={() => navigate("/stops")}
                            >
                              <Icon name="arrow-left"></Icon>
                            </button>
                            <h4 className="bio-block-title mx-3">
                              Stop Details
                            </h4>
                          </div>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => setModalVisible(true)}
                          >
                            <Icon name="edit" />
                            <span>Edit</span>
                          </Button>
                        </div>

                        <ul className="list-group list-group-borderless small mt-2">
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Name:
                            </span>
                            <span className="text">{data?.stop?.name}</span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Location:
                            </span>
                            <span
                              onClick={handleopen}
                              className="btn btn-link btn-sm cursor-pointer p-0"
                            >
                              View In Map{" "}
                              <Icon name="map-pin" className="me-1" />
                            </span>
                          </li>
                        </ul>
                      </div>

                      <div className="bio-block border-top pt-3">
                        <h4 className="bio-block-title mb-2">Assigned Buses</h4>
                        {data?.assignments?.length > 0 ? (
                          data?.assignments?.map((item, index) => (
                            <Card key={index} className="p-2 mb-3">
                              <div className="d-flex flex-column">
                                <span className="fw-bold">
                                  {item?.bus.number_plate}
                                </span>
                                <small>{item?.shift.name}</small>
                              </div>
                            </Card>
                          ))
                        ) : (
                          <p style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                            No Driver Assigned.
                          </p>
                        )}
                      </div>
                    </Card.Body>
                  </div>
                 
                  <div className="card-content col-sep flex-fill">
                    <Card.Body className="p-0">
                      <div className="border-bottom px-3 py-2">
                        <h4>Active Bus Passes</h4>
                      </div>
                      {data?.active_passes?.length === 0 ? (
                        <div className="p-2 text-center">
                          There are no records found.
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table fs-6 mb-0">
                            <thead className="custom-thead table-light">
                              <tr>
                                <th>Employee</th>
                                <th>Route No.</th>
                                <th>Bus</th>
                                <th>Validity</th>
                                <th>Inbound Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.active_passes.map((row, index) => {
                                const employee = row?.employee;
                                const start = new Date(
                                  `1970-01-01T${row.departure_time}`
                                );
                                const validity = `${format(
                                  new Date(row.start_date),
                                  "d MMMM yyyy"
                                )} To ${format(
                                  new Date(row.end_date),
                                  "d MMMM yyyy"
                                )}`;

                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <div className="me-2">
                                          {employee?.profile_photo ? (
                                            <img
                                              src={`${process.env.REACT_APP_BASE_URL}${employee.profile_photo}`}
                                              alt="user"
                                              className="rounded-circle"
                                              width="36"
                                              height="36"
                                            />
                                          ) : (
                                            <div
                                              className="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center"
                                              style={{
                                                width: 36,
                                                height: 36,
                                                fontSize: "0.875rem",
                                              }}
                                            >
                                              {toInitials(employee?.name)}
                                            </div>
                                          )}
                                        </div>
                                        <div>
                                          <Link
                                            to={`/employee/${employee?.id}`}
                                            className="text-uppercase fw-semibold text-primary d-block"
                                          >
                                            {employee?.name}
                                          </Link>
                                          <Link
                                            to={`/employee/${employee?.id}`}
                                            className="text-muted small d-block"
                                          >
                                            {employee?.email}
                                          </Link>
                                        </div>
                                      </div>
                                    </td>
                                    <td>{row.route?.route_number || "-"}</td>
                                    <td>{row.bus?.number_plate || "N/A"}</td>
                                    <td>{validity}</td>
                                    <td>{format(start, "h.mm a")}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </Card.Body>
                  </div>
                </div>
              </Card>
            </Tab.Pane>
          </Tab.Content>
          
        </Block>
      </Tab.Container> */}
      <div className="card">
        <div className="row px-2">
          <div className="col-12 col-md-4 border-end p-4">
            <div className="bio">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={() => navigate("/stops")}
                  >
                    <Icon name="arrow-left"></Icon>
                  </button>
                  <h4 className="bio-block-title mx-3">Stop Details</h4>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => setModalVisible(true)}
                >
                  <Icon name="edit" />
                  <span>Edit</span>
                </Button>
              </div>

              <ul className="list-group list-group-borderless small mt-2">
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Name:
                  </span>
                  <span className="text">{data?.stop?.name}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Location:
                  </span>
                  <span
                    onClick={handleopen}
                    className="btn btn-link btn-sm cursor-pointer p-0"
                  >
                    View In Map <Icon name="map-pin" className="me-1" />
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-8 p-0">
            <Card.Body className="p-0">
              <div className="border-bottom px-3 py-2">
                <h4>Active Bus Passes</h4>
              </div>
              {/* {data?.active_passes?.length === 0 ? (
                <div className="p-2 text-center">
                  There are no records found.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table fs-6 mb-0 align-middle">
                    <thead className="custom-thead table-light">
                      <tr>
                        <th>Employee</th>
                        <th>Route No.</th>
                        <th>Bus</th>
                        <th>Validity</th>
                        <th>Inbound Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.active_passes.map((row, index) => {
                        const employee = row?.employee;
                        const start = new Date(
                          `1970-01-01T${row.departure_time}`
                        );
                        const validity = `${format(
                          new Date(row.start_date),
                          "d MMMM yyyy"
                        )} To ${format(new Date(row.end_date), "d MMMM yyyy")}`;

                        return (
                          <tr key={index}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="me-2">
                                  {employee?.profile_photo ? (
                                    <img
                                      src={`${process.env.REACT_APP_BASE_URL}${employee.profile_photo}`}
                                      alt="user"
                                      className="rounded-circle"
                                      width="36"
                                      height="36"
                                    />
                                  ) : (
                                    <div
                                      className="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center"
                                      style={{
                                        width: 36,
                                        height: 36,
                                        fontSize: "0.875rem",
                                      }}
                                    >
                                      {toInitials(employee?.name)}
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <Link
                                    to={`/employee/${employee?.id}`}
                                    className="text-uppercase fw-semibold text-primary d-block"
                                  >
                                    {employee?.name}
                                  </Link>
                                  <Link
                                    to={`/employee/${employee?.id}`}
                                    className="text-secondary small d-block"
                                  >
                                    {employee?.email}
                                  </Link>
                                </div>
                              </div>
                            </td>
                            <td>{row.route?.route_number || "-"}</td>
                            <td>{row.bus?.number_plate || "N/A"}</td>
                            <td>{validity}</td>
                            <td>{format(start, "h.mm a")}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )} */}
              <StopActivePass stopid={id}/>
            </Card.Body>
          </div>
        </div>
      </div>
      <Dialog open={mapOpen} onClose={handleclose} fullWidth maxWidth="md">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Map View
          <IconButton
            aria-label="close"
            onClick={handleclose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <IoCloseOutline />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            p: "0", // fixed height in px
          }}
        >
          <DialogContentText
            sx={{
              p: "0", // fixed height in px
            }}
          >
            <Stopmap data={data?.stop} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Addstopmodal
        title="Edit Stop"
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        onsubmit={handlesubmit}
        isAddSubmiting={isAddSubmiting}
        lat={data?.stop?.latitude}
        lng={data?.stop?.longitude}
        name={data?.stop?.name}
      />
      {/* <Modal
        show={modalVisible}
        onHide={handleToggleModal}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Bus</Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          <div className="filter-sections">
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Stop Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter Stop Name"
                value={addFormFields.name}
                onChange={(e) =>
                  setAddFormFields({ ...addFormFields, name: e.target.value })
                }
              />
            </div>
            <div className="d-flex justify-content-between gap-3 align-items-center">
              <div className="mb-3 w-100">
                <label htmlFor="latitude" className="form-label">
                  Latitude
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="latitude"
                  placeholder="Enter Latitude"
                  value={addFormFields.latitude}
                  onChange={(e) =>
                    setAddFormFields({
                      ...addFormFields,
                      latitude: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mb-3 w-100">
                <label htmlFor="longitude" className="form-label">
                  Longitude
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="longitude"
                  placeholder="Enter Longitude"
                  value={addFormFields.longitude}
                  onChange={(e) =>
                    setAddFormFields({
                      ...addFormFields,
                      longitude: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            disabled={isAddSubmiting}
            onClick={handleToggleModal}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            disabled={isAddSubmiting}
            onClick={handleSubmit}
          >
            Update{" "}
            {isAddSubmiting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.data?.role || "data",
});

export default connect(mapStateToProps)(StopDetailsPage);
